/**
 * Batesky policy document, hosted verbatim from the source content.
 * Do not reword; kept as-is per product requirement.
 */
export const copyrightPolicy = {
  title: "Copyright Policy",
  lastUpdated: "July 7, 2025",
  body: `## Notification of Copyright Infringement
Batesky ("Batesky") respects the intellectual property rights of others and expects its users to do the same.  

It is Batesky's policy, in appropriate circumstances and at its discretion, to disable the visiblity of users accounts or posts who repeatedly infringe the copyrights of others.  

Bluesky Account data (like profiles and posts) are stored by Bluesky on their respective data servers and Batesky has no ability to remove content.  

To remove infringing content, please contact Bluesky directly. See Bluesky's copyright policy at: [https://bsky.social/about/support/copyright](https://bsky.social/about/support/copyright).  

There, you can fill out a **Copyright Request Form** to have appropriate measures taken (such as content removal).`,
}
